<template>
  <a
    href="#"
    class="social-btn twl-btn"
    :style="loginButtonStyles"
    @click.prevent="showTwilioFields"
  >
    <i v-show="baseData.flags.loginBtnIcons" class="fa fa-commenting" />
    <span v-text="$t('sms')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    name: 'TwilioButton',
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#0084ff',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.layouts.appLayout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.fonts.alignments.loginBtns
      },
      loginButtonColor() {
        return this.baseData.colors.loginBtns.smsBtn
      },
      loginButtonTextColor() {
        return this.baseData.colors.loginBtns.loginBtnText
      },
    },
    methods: {
      showTwilioFields() {
        logUserAction({ type: 'user_action', label: 'User Clicked Twilio Connect Button' })
        this.$eventHub.$emit('showTwilio', true)
      },
    },
  }
</script>

<style>
  .twl-btn {
    background: #0084ff;
  }
  .twl-btn:hover {
    background: #0067cc;
  }
</style>
